import type { FC } from 'react';
import React, { createContext, useCallback, useContext, useMemo } from 'react';
import type {
    WidgetContextProps,
    WidgetContextProviderProps,
} from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/providers/widget-provider/types';

export const WidgetContext = createContext<WidgetContextProps>({
    containerRef: {
        current: null,
    },
    scrollTop: () => {},
});

export const WidgetContextProvider: FC<WidgetContextProviderProps> = ({
    children,
    containerRef,
}) => {
    const scrollTop = useCallback(() => {
        containerRef.current?.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }, [containerRef]);

    const value = useMemo(() => ({ containerRef, scrollTop }), [containerRef, scrollTop]);

    return <WidgetContext.Provider value={value}>{children}</WidgetContext.Provider>;
};

export const useWidgetContext = () => useContext(WidgetContext);
